import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {Client} from '@app/interfaces/entities/client';
import {firstValue} from '@app/util/object.helper';

@Component({
    selector: 'app-form-input-client-search',
    templateUrl: './form-input-client-search.component.html',
    styleUrls: ['./form-input-client-search.component.scss'],
    standalone: false
})
export class FormInputClientSearchComponent implements OnInit {

  @Input() control: FormControl;

  @Input() field: Field<any>;

  public searching = false;

  public selectedName: string | null = null;

  ngOnInit(): void {
    this.selectedName = this.control.value ? firstValue(this.control.value) : null;
    this.searching = !this.selectedName;
  }

  get entityGroupTypeIds(): string[] {
    return this.field?.config?.entity_group_type_ids ?? [];
  }

  startSearching(): void {
    this.searching = true;
  }

  onClientSelected(client: Client): void {
    // The "Ni rezultatov" option and a cancelled quick-create dialog can
    // both emit a falsy/incomplete value here - ignore rather than persist
    // an empty selection or throw on client.clientUuid.
    if (!client?.clientUuid) {
      return;
    }

    this.control.setValue({[client.clientUuid]: client.name});
    this.selectedName = client.name;
    this.searching = false;
  }

  clearSelection(): void {
    this.control.setValue(null);
    this.selectedName = null;
    this.searching = true;
  }
}
